import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JSConfetti from 'js-confetti';
import { FormattedMessage } from 'react-intl';

import imgixConfig from 'Config/imgix';

import 'Components/Order/KeyReveals/Pinata/PinataReveal.scss';

export default function PinataReveal({ setRevealStep, uniqueId }) {
  const [revealed, setRevealed] = useState(false);
  const [canvas, setCanvas] = useState();
  const [whacks, setWhacks] = useState(0);

  const canvasRef = useRef(canvas);

  useEffect(() => {
    canvasRef.current = document.getElementById(`confetti-canvas-${uniqueId}`);
    setCanvas(canvasRef.current);
  }, [canvas, setCanvas, uniqueId]);

  const jsConfetti = new JSConfetti({ canvas });

  const revealAnimation = () => {
    jsConfetti.addConfetti({
      confettiColors: [
        '#fa9635',
        '#f7ec1f',
        '#f9b53b',
        '#fd734d',
        '#e79922',
        '#c92e1f',
        '#a02b0a',
        '#36431f',
      ],
    });
    setRevealed(true);

    setTimeout(() => {
      setRevealStep(3);
    }, 750);
  };

  const hitThePinata = () => {
    setWhacks(whacks + 1);

    if (whacks === 2) {
      revealAnimation();
    }
  };

  return (
    <>
      <div className="PinataReveal">
        <div className="PinataReveal__pinataContainer">
          <div className="PinataReveal__rope" />
          <button
            className={classNames('PinataReveal__pinata', { 'PinataReveal__pinata--open': revealed }, { 'PinataReveal__pinata--one': whacks === 1 }, { 'PinataReveal__pinata--two': whacks === 2 })}
            onClick={() => { hitThePinata(); }}
          >
            <div className="PinataReveal__pinata__all">
              <div className="PinataReveal__pinata__top">
                <img src={`https://fanatical.imgix.net/production/assets/mystery/pinata/2023/fiesta/pinata-top.png?${imgixConfig}`} alt="Pinata Top" />
              </div>
              <div className="PinataReveal__pinata__bottom">
                <img src={`https://fanatical.imgix.net/production/assets/mystery/pinata/2023/fiesta/pinata-bottom.png?${imgixConfig}`} alt="Pinata Bottom" />
              </div>
            </div>
          </button>
        </div>
        <div className="PinataReveal__hitText">
          <FormattedMessage id="pinata-reveal.hit-text" defaultMessage="Hit the piñata 3 times to reveal your games!" />
        </div>
      </div>
      <canvas id={`confetti-canvas-${uniqueId}`} className="pinataCanvas" />
    </>
  );
}

PinataReveal.propTypes = {
  setRevealStep: PropTypes.func,
  uniqueId: PropTypes.string,
};

PinataReveal.defaultProps = {
  setRevealStep: () => {},
  uniqueId: '',
};
